import { Box, Typography } from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import OddsChip from "../race/chip";
import { CurrencyIcon } from "../../../constants/assets";

export const MobileActivityCard = ({ activity, index }) => (
  <Box
    sx={{
      p: 2,
      backgroundColor: index % 2 === 0 ? "#1E1E1E" : darkColors.background,
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box textAlign={"left"} sx={{ mb: 1 }}>
        <Typography
          fontFamily={"MontserratBold"}
          color="white"
          fontSize={fontSizes.heading3}
        >
          {activity.name}
        </Typography>
        <Typography fontSize={fontSizes.body}>
          <Box component="span" sx={{ color: darkColors.tableGreen }}>
            {activity.status}
          </Box>{" "}
          <Box component="span" sx={{ color: darkColors.lightGray }}>
            {activity.type === "race" ? "Race at" : "For Placing Bet On"}{" "}
          </Box>
          <Box component="span" sx={{ color: "white" }}>
            {activity.location}
          </Box>
        </Typography>
      </Box>
      {/* <OddsChip
        odds={activity.odds}
        width={80}
        boxShadow="-2px 0px 30px rgba(199, 123, 30, 0.7)"
        px={2}
      /> */}
    </Box>

    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "start", color: "white" }}>
        <Box sx={{ display: "flex", alignItems: "start" }}>
          <Typography pt={0.2}>
            <CurrencyIcon />
          </Typography>
          +{activity.totalWinning}
        </Box>
      </Box>

      <Typography
        fontSize={fontSizes.body}
        sx={{ color: "white", fontWeight: 700 }}
      >
        {activity.timestamp}
      </Typography>
    </Box>
  </Box>
);
